import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Plus } from "lucide-react";
import SellViewtable from "./Components/SellAsViewTable";
import SellasAddProduct from "./SellAsAddPack";
import { NavLink, useNavigate } from "react-router-dom";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";

const SellasViewAddProduct = () => {
  const [addpack, setaddpack] = useState(true);
  const navigate = useNavigate();

  return (
    <div>
      <BreadCrumbsContainer />
      <div className=" bg-white ml-[2.083333vw]  mr-[2.638888vw] h-[84vh] overflow-y-scroll no-scrollbar">
        <div className="flex flex-col box-border w-[100]">
          <div className="w-[60%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[3.0375235vh] font-medium font-outfit mt-[3.51vh]">
            <div onClick={() => navigate(-1)}>
              <ArrowLeft size={20} className=" cursor-pointer" />
            </div>
            <span className="mx-4">Sell As</span>
          </div>
          <div className="flex items-center mx-[2.52222vw] mt-3 justify-start flex-row gap-x-4 mb-[3.51vh]">
            <p className="font-outfit text-[2vh] font-normal">
              Product ID: <span className="underline">VKC/3064</span>
            </p>
            <p className="font-outfit text-[2vh] font-normal">
              Product Name: <span>Snackers</span>
            </p>
            <p className="font-outfit text-[2vh] font-normal">
              Color: <span>Black</span>
            </p>
            <p className="font-outfit text-[2vh] font-normal">
              MRP(₹): <span>500</span>
            </p>
          </div>
          <div className=" border-[1px] border-[#acacac]"></div>
        </div>

        <div className="flex flex-row mt-6 items-start justify-start gap-x-3 mx-[2.52222vw]">
          <button
            className={`${
              addpack === true
                ? "border-[2px] border-[#5652B0] bg-[#EAD8FC]"
                : "border-[1px] border-[#acacac]"
            } rounded-lg px-3 py-2 text-[2.2003745vh] font-medium font-outfit flex items-center justify-center flex-row1`}
            onClick={() => setaddpack(true)}>
            {" "}
            <Plus color="#333333" />{" "}
            <span className="px-2 text-[#333333]">Add Packs</span>
          </button>
          <button
            className={`${
              addpack === false
                ? "border-[2px] border-[#5652B0] bg-[#EAD8FC]"
                : "border-[1px] border-[#acacac]"
            } rounded-lg px-3 py-2 text-[2.2003745vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row `}
            onClick={() => setaddpack(false)}>
            {" "}
            <span className="px-2 text-black">View Packs</span>
          </button>
        </div>

        {addpack === false ? (
          <>
            <div className="grid grid-cols-3 gap-4 px-[2.2222vw] mt-7 ">
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
              <SellViewtable />
            </div>

            <div className="flex flex-row mt-9 items-start justify-start mx-[2.522222vw] gap-x-3 pb-14  ">
              <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[16px] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
                <ArrowLeft color="#5652B0" />{" "}
                <span className="px- text-[#5652B0] px-3">Go Back</span>
              </button>
              <button className="rounded-md px-9 py-[10px] text-[16px] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
                {" "}
                <span className="px-2 text-white ">Confirm Pack</span>{" "}
                <ArrowRight color="#ffffff" />
              </button>
            </div>
          </>
        ) : (
          <SellasAddProduct />
        )}
      </div>
    </div>
  );
};

export default SellasViewAddProduct;
